import FormError from './form-error.model';

class SubTransaction {
  constructor(key) {
    this.key = key;

    this.username = '';
    this.code = '';
    this.amount = null;
  }
}

class TransferForm {
  constructor(products, customerProducts) {
    this.subTransactions = [];
    this.transactionPassword = null;

    this.products = products;
    this.customerProducts = customerProducts;

    this.hasError = false;
    this.error = new FormError();
    this.nextItemKey = 0;
    this.isUsingGoogleTwoFactor = false;

    if (this.customerProducts.length === 0) {
      this.fromProduct = this.customerProducts[0].id;
    }

    this.addSubTransaction();
  }

  addSubTransaction() {
    let subTransaction = new SubTransaction(this.nextItemKey);

    if (this.products.length === 0) {
      subTransaction.code = this.products[0].code;
    }

    this.subTransactions.push(subTransaction);
    this.nextItemKey++;
  }

  removeSubTransaction(subTransaction) {
    for (let i = 0; i < this.subTransactions.length; i++) {
      if (this.subTransactions[i].key === subTransaction.key) {
        this.subTransactions.splice(i, 1);
        break;
      }
    }
  }

  get totalAmount() {
    let totalAmount = 0;

    angular.forEach(this.subTransactions, (subTransaction) => {
      totalAmount += Number(subTransaction.amount);
    });

    return totalAmount;
  }

  get isValid() {
    return this.subTransactions.length > 0;
  }

  authenticationSwitched(isUsingGoogleTwoFactor) {
    this.isUsingGoogleTwoFactor = isUsingGoogleTwoFactor;
  }

  toPayload() {
    let payload = {
      transfer: {
        usingGoogleAuthPassword: this.isUsingGoogleTwoFactor,
      }
    };

    payload['transfer']['from'] = this.fromProduct;

    let subTransactions = {};

    for (let subTransaction of this.subTransactions) {
      subTransactions[subTransaction.key] = {
        code: subTransaction.code,
        username: subTransaction.username,
        amount: subTransaction.amount
      };
    }

    payload['transfer']['to'] = subTransactions;
    payload['transfer']['transactionPassword'] = this.transactionPassword;

    return payload;
  }
}

export default TransferForm;



// WEBPACK FOOTER //
// ./client/app/pages/customer/peertopeer/model/form.model.js